import { render, staticRenderFns } from "./EconomicGroup.vue?vue&type=template&id=1237c83f&scoped=true"
import script from "./EconomicGroup.vue?vue&type=script&lang=ts"
export * from "./EconomicGroup.vue?vue&type=script&lang=ts"
import style0 from "./EconomicGroup.vue?vue&type=style&index=0&id=1237c83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237c83f",
  null
  
)

export default component.exports